import React from "react";
import { useTranslation } from 'react-i18next';
import ShandianBeige from "../Components/quarries/ShandianBeige";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import productSeoData from "../data/productSeoData.json";

function ShandianBeigePage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = productSeoData[currentLang]?.shandianBeige || {
    title: currentLang === 'tr' ? 'Shandian Beige Mermer - MOCA Mermer' : 'Shandian Beige Marble - MOCA Marble',
    description: currentLang === 'tr' ? 'Shandian Beige mermer ürünü hakkında detaylı bilgi. MOCA Mermer kalitesi ile.' : 'Detailed information about Shandian Beige marble product. With MOCA Marble quality.',
    keywords: currentLang === 'tr' ? 'shandian beige, mermer, doğal taş, moca mermer' : 'shandian beige, marble, natural stone, moca marble'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/shandianbeige"
        image={seo.image}
        structuredData={seo.structuredData}
      />
      <TopBar />
      <Spacer/>
      <ShandianBeige />
    </>
  );
}

export default ShandianBeigePage;
